import './style.css';
import NodeComponent from "../node";
import {SettingNodeIcon} from "./icons";

export function MessagePromptNode({ id, data }) {
    return (
        <NodeComponent title="Message" id={id} data={data} nodeTypeIcon={<SettingNodeIcon/>}>
            <div></div>
        </NodeComponent>
    );
}

